import React from "react";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "./button";
import { Typography } from "./typography";

interface StackFormButtonsProps {
  onBack: () => void;
  onContinue?: () => void;
  continueText?: string;
  isSubmitType?: boolean;
  disabled?: boolean;
  variant?: "default" | "rounded";
  loading?: boolean;
}

const StackFormButtons: React.FC<StackFormButtonsProps> = ({
  onBack,
  onContinue,
  continueText = "Continue",
  isSubmitType = true,
  disabled = false,
  variant = "default",
  loading = false,
}) => {
  const buttonStyle = variant === "rounded" ? "rounded-full" : "";
  const backButtonStyle =
    variant === "rounded" ? "hover:bg-gray-50 transition-colors" : "";

  const isButtonDisabled = loading || disabled;

  return (
    <div className="flex justify-center py-4">
      <div className="relative w-fit flex flex-col md:flex-row gap-4 md:gap-0">
        <button
          type="button"
          onClick={onBack}
          disabled={loading}
          className={`p-3 md:p-4 flex items-center justify-center gap-2 relative md:absolute left-0 md:-left-20 border border-gray-200 rounded-full ${backButtonStyle} ${
            loading ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          <ArrowLeft size={20} className="text-text-secondary" />
          <Typography
            variant="span"
            className="d-block md:hidden text-text-secondary"
          >
            Back
          </Typography>
        </button>
        <Button
          type={isSubmitType ? "submit" : "button"}
          onClick={!isSubmitType ? onContinue : undefined}
          disabled={isButtonDisabled}
          className={`btn-primary py-3.5 h-auto max-w-[300px] min-w-[300px] ${buttonStyle}`}
        >
          {loading ? (
            <div className="flex items-center gap-2">
              <Loader2 className="h-4 w-4 animate-spin" />
              Loading...
            </div>
          ) : (
            continueText
          )}
        </Button>
      </div>
    </div>
  );
};

export default StackFormButtons;
